<template>
    <multiselect v-model="model"
                 :track-by="trackBy"
                 :placeholder="placeholder"
                 open-direction="bottom"
                 :options="options"
                 :searchable="true"
                 :internal-search="true"
                 :clear-on-select="false"
                 :close-on-select="true"
                 :options-limit="300"
                 :max-height="600"
                 :show-no-results="false"
                 :hide-selected="false"
                 :show-no-options="false"
                 :multiple="multiple"
                 :selectedLabel="$t('select.selected')"
                 :label="label"
                 :class="{ 'border border-danger': hasError }">
        <template slot="option" slot-scope="props">
            <slot name="option" v-bind:option="props.option"></slot>
        </template>
        <template slot="singleLabel" slot-scope="props">
            <slot name="singleLabel" v-bind:option="props.option"></slot>
        </template>
        <template slot="tag" slot-scope="props">
            <slot name="tag" v-bind:option="props.option"></slot>
        </template>
        <template v-slot:no-options>NO</template>
    </multiselect>
</template>

<script>
    import multiselect from 'vue-multiselect'
    let _ = require('lodash')

    export default {
        props: {
            'options': Array,
            'value': [ Number, Array, String ],
            'trackBy': {
                type: String,
                default: 'id'
            },
            'placeholder': {
                type: String,
                default: 'Type to search'
            },
            'hasError': Boolean,
            'multiple': Boolean,
            'label': String
        },
        data() {
            return {
                timingSearch: ''
            }
        },
        components: {
            multiselect
        },
        methods: {
            getValFromIndex(index) {
                if (index) {
                    if (this.trackBy) {
                        if (typeof index === 'object') {
                            return index[this.trackBy]
                        }
                        else {
                            return _(this.options).filter((item) => { return item[this.trackBy] === index }).head()
                        }
                    }
                    else {
                        return this.options[index]
                    }
                }
                return null
            }
        },
        computed: {
            model: {
                get() {
                    return this.multiple ? this.value : this.getValFromIndex(this.value)
                },
                set(val) {
                    const v = this.getValFromIndex(val)
                    const value = this.multiple ? val : v
                    this.$emit('input', value)
                }
            }
        }
    }
</script>